// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__kQjGn","container":"navbar_container__VQHfT","logo":"navbar_logo__gONTT","menu":"navbar_menu__edd-u"};